import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import React from 'react';
import AgiliteImg from '../../upload/valeur-agilite.jpg';
import CreativiteImg from '../../upload/valeur-creativite.jpg';
import ExigenceImg from '../../upload/valeur-exigence.jpg';
import classes from './Zoom.module.scss';

class Zoom2 extends React.Component {
	render() {
		return (
			<>
				<div className={classes.Gradient}>
					<div className={classes.Title}>valeurs</div>
					<div className={classes.SecondaryTitle}>
						Agilité, créativité et exigence
						<br />
						au cœur de notre ADN{' '}
					</div>
				</div>
				<div className={classes.Content}>
					<div className={classes.TimelineContainer}>
						<div className={classes.TimelineStep}>
							<div className={classes.TimelineSide}>
								<img
									className={[classes.AgiliteImg, classes.FloatRight].join(' ')}
									src={AgiliteImg}
									alt="homme_sautant"
								/>
							</div>
							<ArrowRightIcon className={classes.RightArrow} />
							<div className={classes.TimelineSide}>
								<div className={classes.TimelineText}>
									<b>L’agilité est au cœur de notre façon de faire.</b>
									<br />
									Nous n’avons pas d’a priori qui nous empêcherait de nous
									adapter rapidement à la réalité du terrain et aux besoins de
									nos clients. Pour nous, appartenir à un groupe familial est
									une garantie d’ancrage et de stabilité qui nous permet
									d’avancer avec audace pour proposer des solutions innovantes
									parce que rapides et flexibles.
								</div>
							</div>
						</div>
						<div
							className={[classes.TimelineStep, classes.SpecialSide].join(' ')}
						>
							<div className={classes.TimelineSide}>
								<div
									className={[
										classes.TimelineText,
										classes.FloatRight,
										classes.PaddingRight,
									].join(' ')}
								>
									<b>
										La créativité est au cœur de notre façon <br />
										d’envisager la vie.
									</b>
									<br />
									Pour cela, nous sommes à l’écoute de nos clients et des
									besoins du marché, mais aussi à l’écoute des idées.
									L’inventivité et l’innovation font partie de notre ADN. Nous
									ne laissons aucune mauvaise raison nous empêcher de sortir du
									cadre afin d’imaginer des solutions nouvelles. Nous sommes
									attentifs et disponibles, et désirons rester toujours ouverts
									aux autres. Notre exigence et notre capacité à créer nous
									portent à vouloir être les premiers, mais nous n’y sacrifions
									pas pour autant notre désir de rester simples et fidèles à
									nous-mêmes.
								</div>
							</div>
							<ArrowLeftIcon className={classes.LeftArrow} />
							<div className={[classes.TimelineSide].join(' ')}>
								<img
									className={classes.CreativiteImg}
									src={CreativiteImg}
									alt="grafitti"
								/>
							</div>
						</div>
						<div className={classes.TimelineStep}>
							<div className={classes.TimelineSide}>
								<img
									className={[classes.ExigenceImg, classes.FloatRight].join(
										' ',
									)}
									src={ExigenceImg}
									alt="metronome"
								/>
							</div>
							<ArrowRightIcon className={classes.RightArrow} />
							<div className={classes.TimelineSide}>
								<div className={classes.TimelineText}>
									<b>
										Nous prenons plaisir à développer des projets, des visions,
										des patrimoines, des territoires.
									</b>
									<br />
									Pour cela, il nous faut toujours savoir accompagner et sans
									cesse nous adapter. Accompagner comme un partenaire et non
									comme un fournisseur. S’adapter pour trouver des solutions
									sur-mesure qui nous forcent à nous remettre en cause.
								</div>
							</div>
						</div>
					</div>
					<div className={classes.CenterHolder}>
						<div className={classes.LinkHolder}>
							<div className={classes.Weblink}>groupeduval.com</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Zoom2;
